//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"AlongOrientationOption",1,0],[1,"AlongPathRotationAngle",0,"Expression",0],[0,"AxialOrientationOption",1,0],[0,"CircularOrientationOption",1,0],[0,"FollowFaceProjDirOption",1,0],[0,"FollowFaceSelection",0,"ScCollector",0],[0,"FollowFaceToggle",1,0],[0,"FromCSYS",1,"CoordinateSystem",0],[0,"GeneralOrientationOption",1,0],[0,"HelixOrientationOption",1,0],[0,"LinearOrientationOption",1,0],[0,"MirrorOrientationOption",1,0],[0,"OrientationOption",1,1],[0,"PolygonOrientationOption",1,0],[0,"RepeatTransformSetting",1,0],[0,"SpiralOrientationOption",1,0],[0,"ToCSYS",1,"CoordinateSystem",0],[0,"UserDefinedProjDir",1,"Direction",0],[0,"VectorForAlong",1,"Direction",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.PatternOrientation = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.PatternOrientation";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.PatternOrientation.Enum = Object.freeze({
    "Fixed" : "Fixed", "NormalToPath" : "NormalToPath", "NormalToVector" : "NormalToVector", "ParallelToVector" : "ParallelToVector", "ThroughAxis" : "ThroughAxis", "FollowPattern" : "FollowPattern", "FollowCSYS" : "FollowCSYS", "CSYStoCSYS" : "CSYStoCSYS"});

SPLM.GeometricUtilities.PatternOrientation.ProjDirEnum = Object.freeze({
    "PatternPlaneNormal" : "PatternPlaneNormal", "NormalToFace" : "NormalToFace", "RadialDir" : "RadialDir", "UserDefinedVector" : "UserDefinedVector", "AxialDir" : "AxialDir"});

export default SPLM;